import { css } from '@emotion/react';
import React from 'react';

import Card from '@/core/components/layout/Card.component';
import { useTranslation } from '@/i18n';
import { Markdown } from '@/markdown';
import { Spacer } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';
import { BodyCopy, Heading } from '@/ui/typography';

interface AnyQuestionsCardProps {
  email: string;
  phone?: string;
  faqUrl?: string;
  after?: React.ReactNode;
  className?: string;
}

export const AnyQuestionsCard = (props: AnyQuestionsCardProps) => {
  const { t } = useTranslation('confirmation');

  const {
    componentProperties: { confirmation },
  } = useTheme();

  return (
    <Card className={props.className}>
      <Heading
        as="h2"
        style="heading5"
        css={css({
          ...confirmation?.anyQuestionsCard?.title,
          ['@media all and (max-width: 730px)']:
            confirmation?.anyQuestionsCard?.title?.mobile,
        })}
      >
        {t('faq.sectionTitle')}
      </Heading>
      <Spacer s="xs" />
      <BodyCopy css={confirmation?.anyQuestionsCard?.description}>
        <Markdown
          source={t('faq.body', {
            email: props.email,
            phoneNumber: props.phone,
            faqUrl: props.faqUrl,
          })}
          allowHtml
        />
      </BodyCopy>
      {props.after ? (
        <>
          <Spacer s="l" />
          {props.after}
        </>
      ) : null}
    </Card>
  );
};
